const login = {
  form: {
    username: 'Username',
    password: 'Password',
    login_button: 'Login'
  }
}

export default login
